import axios from "axios";

const ACCESS_TOKEN_KEY = "evoAccessToken";

const axiosInstance = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken =
      localStorage.getItem(ACCESS_TOKEN_KEY);

    if (accessToken) {
      config.headers = config.headers || {};
      config.headers.Authorization =
        `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 401 &&
      localStorage.getItem(ACCESS_TOKEN_KEY)
    ) {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
    }

    return Promise.reject(error);
  }
);

export {
  ACCESS_TOKEN_KEY,
};

export default axiosInstance;
